'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('VipaDataCtrl', ['$scope', '$filter', function ($scope, $filter) {
	let data = (typeof(vipaData) !== 'undefined') ? vipaData : [];
	$scope.filter = '';
	$scope.getPageList = function(){
		return $filter('filter')(data, {$: $scope.filter});
	};
}]);